/* =========================================================
   G36 · FAVORITOS
   - Guarda los handles en localStorage ("wishlist"), igual que antes,
     así los favoritos que ya tenían los clientes se conservan.
   - Un solo listener para todos los corazones (.wishlist-btn),
     incluidos los productos que llegan con "Ver más".
   - Mantiene el contador de la cabecera y el panel de favoritos.
========================================================= */

(function () {
  var KEY = 'wishlist';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cache = {};
  var lastOpener = null;

  function read() {
    try {
      var list = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function toggle(handle) {
    var list = read();
    var on = list.indexOf(handle) === -1;
    list = on ? [handle].concat(list) : list.filter(function (h) { return h !== handle; });
    write(list);
    sync();
    return on;
  }

  function remove(handle) {
    write(read().filter(function (h) { return h !== handle; }));
    sync();
  }

  function sync() {
    paint();
    if (drawer() && drawer().classList.contains('is-open')) render();
  }

  function setAttr(el, name, value) {
    if (el.getAttribute(name) !== value) el.setAttribute(name, value);
  }

  // Corazones y contador; no toca el panel (lo llama el MutationObserver)
  function paint() {
    var list = read();

    document.querySelectorAll('.wishlist-btn[data-product-handle]').forEach(function (btn) {
      var on = list.indexOf(btn.getAttribute('data-product-handle')) !== -1;
      // Solo escribe si cambia (evita recalcular estilos en cada carga de nodos)
      if (btn.classList.contains('is-active') !== on) btn.classList.toggle('is-active', on);
      setAttr(btn, 'aria-pressed', on ? 'true' : 'false');
      setAttr(btn, 'aria-label', on ? 'Quitar de favoritos' : 'Añadir a favoritos');
    });

    document.querySelectorAll('[data-g36-fav-count]').forEach(function (el) {
      // Solo si cambia: reescribir el texto dispara el MutationObserver
      if (el.textContent !== String(list.length)) el.textContent = list.length;
      if (el.hasAttribute('data-g36-fav-badge')) el.hidden = list.length === 0;
    });
  }

  /* ---------------- Panel ---------------- */

  function drawer() {
    return document.querySelector('[data-g36-fav-drawer]');
  }

  function fetchItem(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch(root + 'products/' + encodeURIComponent(handle) + '?view=g36-fav')
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        cache[handle] = html.trim();
        return cache[handle];
      })
      .catch(function () { return ''; });
  }

  function render() {
    var d = drawer();
    if (!d) return;

    var list = read();
    var listEl = d.querySelector('[data-g36-fav-list]');
    var empty = d.querySelector('[data-g36-fav-empty]');
    var loading = d.querySelector('[data-g36-fav-loading]');

    empty.hidden = list.length > 0;
    if (!list.length) {
      listEl.innerHTML = '';
      loading.hidden = true;
      return;
    }

    loading.hidden = list.every(function (h) { return cache[h] !== undefined; });

    Promise.all(list.map(fetchItem)).then(function (items) {
      // Si la lista cambió mientras cargaba, otra llamada a render() se encarga.
      if (read().join() !== list.join()) return;
      listEl.innerHTML = items.join('');
      loading.hidden = true;
      empty.hidden = items.some(Boolean);
    });
  }

  function open(opener) {
    var d = drawer();
    if (!d) return;
    lastOpener = opener || null;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    render();
    var panel = d.querySelector('.g36-fav__panel');
    if (panel) panel.focus();
  }

  function close() {
    var d = drawer();
    if (!d || !d.classList.contains('is-open')) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastOpener) lastOpener.focus();
  }

  /* ---------------- Añadir al carrito desde el panel ----------------
     Cada fila trae (product.g36-fav.liquid):
     - [data-g36-fav-add]: con data-g36-fav-variant si hay una sola variante
       (se añade directo); si no, abre el selector [data-g36-fav-pick].
     - En el selector, el JSON de variantes y un botón por valor de opción.
     La disponibilidad va en cascada: los valores de una opción se marcan
     según lo elegido en las opciones anteriores; así nunca queda atascado.
  ------------------------------------------------------------------- */

  function cartUrl() {
    return (window.Theme && window.Theme.routes && window.Theme.routes.cart_url) || root + 'cart';
  }

  function pickData(pick) {
    if (!pick._g36) {
      var variants = [];
      try {
        variants = JSON.parse(pick.querySelector('[data-g36-fav-variants]').textContent);
      } catch (e) {}
      var names = Array.prototype.map.call(pick.querySelectorAll('.g36-fav-pick__label'), function (el) {
        return el.textContent.trim();
      });
      pick._g36 = { variants: variants, names: names, selected: names.map(function () { return null; }) };
    }
    return pick._g36;
  }

  // ¿Hay alguna variante disponible con este valor y lo elegido antes?
  function valueAvailable(data, index, value) {
    return data.variants.some(function (v) {
      if (!v.available || v.options[index] !== value) return false;
      for (var j = 0; j < index; j++) {
        if (data.selected[j] !== null && v.options[j] !== data.selected[j]) return false;
      }
      return true;
    });
  }

  function selectedVariant(data) {
    if (data.selected.indexOf(null) !== -1) return null;
    return data.variants.filter(function (v) {
      return v.options.every(function (o, i) { return o === data.selected[i]; });
    })[0] || null;
  }

  function paintPick(pick) {
    var data = pickData(pick);
    var item = pick.closest('.g36-fav-item');

    // Recorre las opciones en orden: si una elección deja de ser válida, se suelta
    data.names.forEach(function (_, i) {
      var buttons = pick.querySelectorAll('[data-g36-fav-opt="' + i + '"]');
      buttons.forEach(function (btn) {
        var value = btn.getAttribute('data-value');
        var ok = valueAvailable(data, i, value);
        if (!ok && data.selected[i] === value) data.selected[i] = null;
        btn.disabled = !ok;
        btn.classList.toggle('is-unavailable', !ok);
      });
      // Una sola opción posible → elegida
      var enabled = Array.prototype.filter.call(buttons, function (b) { return !b.disabled; });
      if (data.selected[i] === null && buttons.length === 1 && enabled.length === 1) {
        data.selected[i] = enabled[0].getAttribute('data-value');
      }
      buttons.forEach(function (btn) {
        btn.setAttribute('aria-pressed', data.selected[i] === btn.getAttribute('data-value') ? 'true' : 'false');
      });
    });

    var variant = selectedVariant(data);
    var confirm = pick.querySelector('[data-g36-fav-confirm]');
    var missing = data.selected.indexOf(null);
    confirm.disabled = !(variant && variant.available);
    confirm.textContent = missing !== -1 ? 'Elige ' + data.names[missing].toLowerCase() : 'Añadir';

    var price = item && item.querySelector('[data-g36-fav-price]');
    if (price) {
      if (!price.hasAttribute('data-default')) price.setAttribute('data-default', price.textContent);
      price.textContent = variant ? variant.price : price.getAttribute('data-default');
    }
  }

  function setStatus(item, html, isError) {
    var status = item && item.querySelector('[data-g36-fav-status]');
    if (!status) return;
    status.classList.toggle('is-error', !!isError);
    status.innerHTML = html;
  }

  function escapeHtml(text) {
    var div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  function togglePick(addBtn) {
    var item = addBtn.closest('.g36-fav-item');
    var pick = item && item.querySelector('[data-g36-fav-pick]');
    if (!pick) return;
    var opening = pick.hidden;
    pick.hidden = !opening;
    addBtn.setAttribute('aria-expanded', opening ? 'true' : 'false');
    if (!opening) return;
    setStatus(item, '');
    paintPick(pick);
    var first = pick.querySelector('.g36-fav-pick__value:not(:disabled)');
    if (first) first.focus();
  }

  // Contadores de carrito que pueda haber en la página (cabecera propia o de Horizon)
  function refreshCartCount() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        try {
          sessionStorage.setItem('cart-count', JSON.stringify({ value: String(cart.item_count), timestamp: Date.now() }));
        } catch (e) {}
        document.dispatchEvent(new CustomEvent('g36:cart:updated', { detail: { cart: cart } }));
      })
      .catch(function () {});
  }

  function addToCart(variantId, btn) {
    var item = btn.closest('.g36-fav-item');
    var label = btn.textContent;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = 'Añadiendo…';
    setStatus(item, '');

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (body) {
          if (!r.ok) {
            // 422 = límite de stock u otra regla del carrito: Shopify explica el motivo
            var msg = r.status === 422 && (body.description || body.message);
            if (msg && /cannot find variant/i.test(msg)) msg = 'Esta opción ya no está disponible, G.';
            throw new Error(msg || 'No pudimos añadirla, G. Inténtalo de nuevo.');
          }
          return body;
        });
      })
      .then(function () {
        setStatus(item, '¡Añadido al carrito, G! <a href="' + cartUrl() + '">Ver carrito</a>');
        var pick = item.querySelector('[data-g36-fav-pick]');
        var addBtn = item.querySelector('[data-g36-fav-add]');
        if (pick && !pick.hidden) {
          pick.hidden = true;
          if (addBtn) addBtn.setAttribute('aria-expanded', 'false');
          if (addBtn) addBtn.focus();
        }
        refreshCartCount();
      })
      .catch(function (err) {
        setStatus(item, escapeHtml(err.message), true);
      })
      .then(function () {
        btn.removeAttribute('aria-busy');
        btn.textContent = label;
        btn.disabled = false;
        var pick = btn.closest('[data-g36-fav-pick]');
        if (pick) paintPick(pick);
      });
  }

  /* ---------------- Eventos ---------------- */

  document.addEventListener('click', function (e) {
    var heart = e.target.closest('.wishlist-btn[data-product-handle]');
    if (heart) {
      e.preventDefault();
      e.stopPropagation();
      if (toggle(heart.getAttribute('data-product-handle'))) {
        heart.classList.remove('is-popping');
        void heart.offsetWidth;
        heart.classList.add('is-popping');
      }
      return;
    }

    var removeBtn = e.target.closest('[data-g36-fav-remove]');
    if (removeBtn) {
      remove(removeBtn.getAttribute('data-g36-fav-remove'));
      return;
    }

    var addBtn = e.target.closest('[data-g36-fav-add]');
    if (addBtn) {
      var single = addBtn.getAttribute('data-g36-fav-variant');
      if (single) addToCart(single, addBtn);
      else togglePick(addBtn);
      return;
    }

    var optBtn = e.target.closest('[data-g36-fav-opt]');
    if (optBtn) {
      var pick = optBtn.closest('[data-g36-fav-pick]');
      var data = pickData(pick);
      var i = Number(optBtn.getAttribute('data-g36-fav-opt'));
      var value = optBtn.getAttribute('data-value');
      // Tocar el valor elegido lo suelta
      data.selected[i] = data.selected[i] === value ? null : value;
      setStatus(pick.closest('.g36-fav-item'), '');
      paintPick(pick);
      return;
    }

    var confirmBtn = e.target.closest('[data-g36-fav-confirm]');
    if (confirmBtn) {
      var variant = selectedVariant(pickData(confirmBtn.closest('[data-g36-fav-pick]')));
      if (variant && variant.available) addToCart(variant.id, confirmBtn);
      return;
    }

    var opener = e.target.closest('[data-g36-fav-open]');
    if (opener) {
      e.preventDefault();
      open(opener);
      return;
    }

    if (e.target.closest('[data-g36-fav-close]')) close();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  // Otra pestaña cambió los favoritos
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) sync();
  });

  // Productos que aparecen después (Ver más, recomendaciones, editor del tema).
  // Solo repinta si llegó un corazón o un contador: las apps (Releasit, Forms,
  // Shop Pay…) insertan muchos nodos al cargar y antes cada uno repintaba todo.
  var WATCHED = '.wishlist-btn[data-product-handle], [data-g36-fav-count]';
  function bringsWatched(m) {
    for (var i = 0; i < m.addedNodes.length; i++) {
      var n = m.addedNodes[i];
      if (n.nodeType !== 1) continue;
      if (n.matches(WATCHED) || n.querySelector(WATCHED)) return true;
    }
    return false;
  }
  var pending = false;
  new MutationObserver(function (mutations) {
    if (pending) return;
    if (!mutations.some(bringsWatched)) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      paint();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();
